import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Classes from '../Classes';

const Tag = ({
  tagName, dataDtmAttribute, classes, dataDtm
}) => (
  <span
    className={classnames(Classes.featureTags, classes)}
    data-dtm={dataDtm}
    data-dtm-attributes={JSON.stringify(dataDtmAttribute)}
  >
    {tagName}
  </span>
);

Tag.propTypes = {
  tagName: PropTypes.string.isRequired,
  dataDtmAttribute: PropTypes.object.isRequired,
  dataDtm: PropTypes.string.isRequired,
  classes: PropTypes.string
};

export default Tag;
